import React, { useState } from 'react';
import Table, { TableSize } from '@components/Table';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import SearchPanel from '@components/SearchPanel';
import { translate } from '@utils/i18n';
import useCustomInspections from './hooks/useCustomInspections';
import getColumnsDefinition from './columns';
import { newCustomInspectionPath } from '../../../routes';
import { namespace } from './constants';
import './styles.scss';
function CustomInspectionsContainer() {
    const [searchText, setSearchText] = useState('');
    const { customInspections, loading, toggling, handleToggleActive } = useCustomInspections(searchText);
    return (React.createElement("div", { className: "workspace__body" },
        React.createElement("div", { className: "workspace__major--listing" },
            React.createElement("div", { className: "workspace__header" },
                React.createElement("div", { className: "header__main" },
                    React.createElement("h1", { className: "workspace__title" }, translate('sub_title', { namespace })))),
            React.createElement("article", { id: "filters", className: "qmb-filters" },
                React.createElement("a", { href: newCustomInspectionPath(), className: "qmb-control mt-1 brushaway-button" },
                    React.createElement("i", { className: "fa-light fa-circle-plus" }),
                    translate('new_button', { namespace })),
                React.createElement("div", { className: "filters__group--search" },
                    React.createElement(SearchPanel, { placeholder: translate('search', { namespace: 'filters' }), onChange: setSearchText }))),
            React.createElement("div", null,
                loading && (React.createElement("div", { className: "loading-center" },
                    React.createElement(Loader, { size: LoaderSizes.xlarge }))),
                !loading && (React.createElement(Table, { columns: getColumnsDefinition({ toggling, onToggleActive: handleToggleActive }), data: customInspections, size: TableSize.Full, variant: "listing" })),
                !loading && customInspections.length === 0 && (React.createElement("div", { className: "no-data-message" }, translate('no_inspections', { namespace })))))));
}
export default CustomInspectionsContainer;
